/**
 * Mode save truyền lên server để điều khiển
 */
export default {
  Revenue: 1, // tiểu mục thu
  Expense: 2, // tiểu mục chi
};
